import React, { useEffect, useState } from "react";
import { IRecentCustomersProps } from "./RecentCustomers.types";
import { Stack } from "@fluentui/react";
import { stackTokensWithGap20 } from "../QuotationStyle";
import { CustomersListing } from "../CustomersListing/CustomersListing";
import {
  HeadingMarginStyle,
  ParagraphMarginStyle,
} from "./RecentCustomersStyle";
import { useLocation } from "react-router-dom";

export const RecentCustomers: React.FunctionComponent<IRecentCustomersProps> = (
  props: IRecentCustomersProps
) => {
  const location = useLocation();
  const state = location?.state;
  const [subHeading, setSubHeading] = useState<string>("Recent Customers");
  const [itemsCount, setItemsCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    setItemsCount(0);
    setSubHeading("");
    if (state?.searchingKey?.length >= 3) {
      setSubHeading("Search Results");
    } else {
      setSubHeading("Recent Customers");
    }
  }, [state && state.searchingKey]);
  return (
    <Stack tokens={stackTokensWithGap20} style={{ background: "white" }}>
      <h2 style={HeadingMarginStyle}>{subHeading}</h2>
      {state?.searchingKey?.length >= 3 && !isLoading ? (
        <p style={ParagraphMarginStyle}>
          {`Showing ${itemsCount} result for `}
          <strong>{`"${state.searchingKey}"`}</strong>
        </p>
      ) : null}
      <CustomersListing
        setItemsCount={setItemsCount}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </Stack>
  );
};
